import {
	ArcElement,
	BarElement,
	Chart as ChartJS,
	Legend,
	Tooltip,
} from 'chart.js'

import { Card, CardContent } from '@/modules/shared/components/ui/card'

import { CustomerChartComponent } from '../components/customer-chart.component'
import type { useCustomerProfile } from '../hooks/use-customer-profile.hook'

ChartJS.register(ArcElement, Tooltip, Legend, BarElement)

export type CustomerProfileInterface = ReturnType<typeof useCustomerProfile>

export function CustomerProfileInterface({
	...props
}: CustomerProfileInterface) {
	const { clientSelected, isLoading } = props
	return (
		<div className="space-y-2">
			<Card>
				<CardContent className="pt-5">
					<p className="font-bold">{clientSelected?.razaoSocialNome}</p>
					<p className="text-sm">{clientSelected?.cnpjCpf}</p>
					<p className="text-sm">{`${clientSelected?.logradouro}, ${clientSelected?.numero}`}</p>
					<p className="text-sm">{`${clientSelected?.cidade} - ${clientSelected?.uf}`}</p>
					<p className="text-sm">{clientSelected?.fone}</p>
					<p className="text-sm">
						<a href={`mailto:${clientSelected?.email}`}>
							{clientSelected?.email}
						</a>
					</p>
				</CardContent>
			</Card>
			<CustomerChartComponent {...props} />
		</div>
	)
}
